import React, { useEffect, useState } from 'react';
import './Loading.scss';

export default function Loading({global=false}) {
    return (
        <div className={`loading ${global ? 'global' : ''}`}>
            <picture>
                <source srcSet={'/assets/logo_transparent.webp'} type="image/webp" />
                <img src={'/assets/logo_transparent.png'} alt="Logo Grandir & s'élever ensemble" loading="eager" fetchpriority="high" />
            </picture>
            <img src={'/assets/loading.svg'} alt="Gif de chargement" loading="eager" fetchpriority="high" />
        </div>
    )
}
